import { useEffect, useState } from "react";
import api from "../lib/api";
import CoinCard from "../components/CoinCard";

const Catalog = () => {
  const [coins, setCoins] = useState([]);
  const [filter, setFilter] = useState("all"); // all | available | sold
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/coins")
      .then(({ data }) => setCoins(data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = coins
    .filter((c) => filter === "all" || (filter === "available" ? !c.sold : c.sold))
    .filter((c) =>
      !search ||
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      (c.era || "").toLowerCase().includes(search.toLowerCase()) ||
      (c.origin || "").toLowerCase().includes(search.toLowerCase())
    );

  return (
    <div className="px-6 md:px-12 lg:px-24 py-16">
      <div className="mb-12">
        <div className="coin-tag mb-3">The Complete Catalog</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter">Every Coin, Every Story.</h1>
      </div>

      <div className="flex flex-wrap gap-4 items-center justify-between border-t border-b border-[#F3EFE0]/10 py-4 mb-12">
        <div className="flex gap-2">
          {["all", "available", "sold"].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`coin-tag px-4 py-2 border transition-colors ${
                filter === f
                  ? "border-[#D4AF37] text-[#D4AF37]"
                  : "border-[#F3EFE0]/15 text-[#A19D94] hover:border-[#F3EFE0]/40"
              }`}
              data-testid={`filter-${f}`}
            >
              {f}
            </button>
          ))}
        </div>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name, era, origin…"
          className="bg-transparent border-b border-[#F3EFE0]/20 focus:border-[#D4AF37] outline-none py-2 px-1 text-[#F3EFE0] placeholder-[#6B6A65] w-full sm:w-80"
          data-testid="catalog-search"
        />
      </div>

      {loading ? (
        <div className="text-center py-24 font-display text-2xl text-[#A19D94]">Loading the gallery…</div>
      ) : filtered.length === 0 ? (
        <div className="border border-dashed border-[#F3EFE0]/10 p-16 text-center">
          <p className="font-display text-2xl text-[#A19D94]">No specimens match your inquiry.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-testid="catalog-grid">
          {filtered.map((coin) => (
            <CoinCard key={coin.id} coin={coin} span="col-span-1 md:col-span-4" />
          ))}
        </div>
      )}
    </div>
  );
};

export default Catalog;
